import {
    GETORDERID_SUCCESS,
    GETORDERID_FAILED,
    RESET_GETORDERID,
    LOADING_GETORDERID,
    NETWORK_ERROR_GETORDERID
} from "../types/index";
import { invoiceServices } from "../../config/axios";

const resetGetOrderId = () => {
    return { type: RESET_GETORDERID };
};

const getOrderId =
    (userData, authTokenIs) => async (dispatch) => {
        dispatch({ type: LOADING_GETORDERID });
        await invoiceServices
            .post("getOrderID", userData, { headers: { AuthToken: authTokenIs } })
            .then((res) => {
                switch (res.data.statusInvoiceResult.description) {
                    case "Order ID get successfully for invoice":
                        dispatch(getOrderIdsuccess(res.data));
                        break;
                    default:
                        dispatch(getOrderIdFailed(res.data));
                        break;
                }
            })
            .catch((err) => {
                dispatch({
                    type: NETWORK_ERROR_GETORDERID,
                    payload: err
                });
            });
    };
function getOrderIdsuccess(data) {
    return {
        type: GETORDERID_SUCCESS,
        payload: data
    };
}
function getOrderIdFailed(data) {
    return {
        type: GETORDERID_FAILED,
        payload: data
    };
}

export { resetGetOrderId, getOrderId };
